/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by alejandro.ortega@spazious.com, Fri Feb 09 2024
 */

import { Matrix4, Object3D } from 'three';

import {
  DragControlsHookOptions,
  DragControlsModifier,
  useDragControls,
} from './useDragControls.js';

export interface DragControlsProps extends DragControlsHookOptions {
  enabled?: boolean;
  group?: boolean | Object3D;
  matrixWorld?: Matrix4;
  objects: Object3D[];
  modifiers?: DragControlsModifier[];
  isDraggable?: (object: Object3D) => boolean;
}

export const DragControls: React.FC<DragControlsProps> = ({
  domElement,
  onDrag,
  makeDefault,
  ...restProps
}) => {
  const dragControls = useDragControls({ domElement, onDrag, makeDefault });

  return (
    <group>
      <primitive object={dragControls} {...restProps} />
    </group>
  );
};

export default DragControls;
